import { Navigate, useLocation } from "react-router-dom";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";

const VIEW_RECORDING_RETURN_TO_KEY = "viewRecordingReturnTo";
const VIEW_RECORDING_VIEW_ONLY_KEY = "viewRecordingViewOnly";
const VIEW_RECORDING_ALLOWED_PATH_KEY = "viewRecordingAllowedPath";

const ProtectPrivateRoute = ({ children }) => {
  const isAuthenticated = useIsAuthenticated();
  const { inProgress } = useMsal();
  const location = useLocation();

  if (inProgress !== InteractionStatus.None) {
    return null;
  }

  if (!isAuthenticated) {
    // Redirect to login, but remember where the user was trying to go
    return (
      <Navigate
        to="/"
        replace
        state={{
          from: location,
        }}
      />
    );
  }

  // If this tab is in "view recording only" mode, block all private routes.
  // This ensures a hiring manager who logged in via a share link cannot access dashboard/interviews.
  try {
    const viewOnly = window.sessionStorage.getItem(VIEW_RECORDING_VIEW_ONLY_KEY) === "true";
    const allowedPath = window.sessionStorage.getItem(VIEW_RECORDING_ALLOWED_PATH_KEY);
    if (viewOnly && allowedPath) {
      return <Navigate to={allowedPath} replace />;
    }
  } catch (e) {}

  // After SSO redirect (which returns to /dashboard), honor the saved deep-link once.
  try {
    const returnTo = window.localStorage.getItem(VIEW_RECORDING_RETURN_TO_KEY);
    if (returnTo) {
      window.localStorage.removeItem(VIEW_RECORDING_RETURN_TO_KEY);
      window.sessionStorage.setItem(VIEW_RECORDING_VIEW_ONLY_KEY, "true");
      window.sessionStorage.setItem(VIEW_RECORDING_ALLOWED_PATH_KEY, returnTo);
      return <Navigate to={returnTo} replace />;
    }
  } catch (e) {}

  return children;
};

export default ProtectPrivateRoute;
